import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { SolicitacaoRedefinicaoSenhaService } from '../../services/solicitacao-redefinicao-senha.service';
import { parseBackendResponse } from '../../services/api-response.util';

@Component({
  selector: 'app-redefinicao-senha',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './solicitacao-redefinicao-senha.component.html',
  styleUrls: ['./solicitacao-redefinicao-senha.component.scss']
})
export class RedefinicaoSenhaComponent implements OnInit {
  @Output() fecharModal = new EventEmitter<void>();
  forgotPasswordForm!: FormGroup;
  enviando: boolean = false;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private solicitacaoRedefinicaoSenhaService: SolicitacaoRedefinicaoSenhaService
  ) {}

  ngOnInit() {
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  fechar() {
    this.forgotPasswordForm.reset();
    this.fecharModal.emit();
  }

  enviarEmailRecuperacao() {
    if (this.forgotPasswordForm.invalid) {
      this.forgotPasswordForm.markAllAsTouched();
      this.toastr.warning('Por favor, verifique o campo de email.', 'Formulário Inválido');
      return;
    }

    if (this.enviando) {
      return;
    }

    const email = this.forgotPasswordForm.get('email')?.value;
    this.enviando = true;
    const tempoInicio = Date.now();
    const tempoMinimo = 3000; // 3 segundos

    this.solicitacaoRedefinicaoSenhaService.enviarEmailRedefinicaoSenha(email).subscribe({
      next: (response) => {
        console.log('Resposta do servidor (sucesso):', response);
        const tempoDecorrido = Date.now() - tempoInicio;
        const tempoRestante = Math.max(0, tempoMinimo - tempoDecorrido);

        setTimeout(() => {
          this.enviando = false;
          const parsed = parseBackendResponse(response, 200);
          const mensagem = parsed.mensagem || 'Email de recuperação enviado com sucesso!';
          this.toastr.success(mensagem, 'Email Enviado');
          this.fechar();
        }, tempoRestante);
      },
      error: (err) => {
        console.error('Erro completo:', err);
        console.error('Status:', err.status);
        console.error('Erro error:', err.error);
        console.error('Erro message:', err.message);
        const tempoDecorrido = Date.now() - tempoInicio;
        const tempoRestante = Math.max(0, tempoMinimo - tempoDecorrido);

        setTimeout(() => {
          this.enviando = false;
          
          const parsed = parseBackendResponse(err?.error, err?.status);
          let errorMsg = parsed.mensagem || 'Ocorreu um erro ao enviar o email de recuperação.';
          
          this.toastr.error(errorMsg, 'Erro ao Enviar Email');
        }, tempoRestante);
      }
    });
  }
}

